var _path, _rect, _ellipse, _path2, _ellipse2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCredential(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 145,
    viewBox: "0 0 144 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8863 45.7537H111.337C113.614 45.7537 115.469 47.5903 115.469 49.8619V95.8418C115.469 98.1053 113.622 99.95 111.337 99.95H32.8863C30.6099 99.95 28.7548 98.1134 28.7548 95.8418V49.8619C28.7548 47.5983 30.6018 45.7537 32.8863 45.7537Z",
    fill: "#54DCFC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.1689,
    y: 59,
    width: 26.1,
    height: 26.1,
    rx: 4,
    fill: "#FCFC30"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.42,
    cy: 3.29716,
    rx: 3.42,
    ry: 3.29716,
    transform: "matrix(-1 0 0 1 53.6393 66.2)",
    fill: "#465EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.569 78.0957H57.869C57.869 78.0957 54.8776 73.6994 50.2367 73.6994C45.5957 73.6994 42.569 78.0957 42.569 78.0957Z",
    fill: "#465EFF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.2689,
    cy: 122.9,
    rx: 21.6,
    ry: 1.8,
    fill: "#CCCCCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2689 66.2H106.469",
    stroke: "#465EFF",
    strokeWidth: 4,
    strokeLinejoin: "bevel"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2689 73.4H106.469",
    stroke: "#465EFF",
    strokeWidth: 4,
    strokeLinejoin: "bevel"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2689 80.6H89.3689",
    stroke: "#465EFF",
    strokeWidth: 4,
    strokeLinejoin: "bevel"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4189 45.95V34.7H33.5689",
    stroke: "#465EFF",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120.419 45.95V34.7H108.269",
    stroke: "#465EFF",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4189 99.5V110.75H33.5689",
    stroke: "#465EFF",
    strokeWidth: 4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M120.419 99.5V110.75H108.269",
    stroke: "#465EFF",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredential);
export default __webpack_public_path__ + "static/media/credential.8964a4f90c430831aa26f7b7a1b16982.svg";
export { ForwardRef as ReactComponent };